export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7026.32895700.jpg";